import { useQuery } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';

interface AnalysisTemplate {
  id: number;
  customer_id: number;
  product: string;
  created_by: number;
  visibility: string;
  query: string;
  extra_instructions: string;
  deep_mode: boolean;
  tags: string[];
  updated_at: string;
  created_at: string;
}

const getAnalysisTemplates = async (): Promise<AnalysisTemplate[]> => {
  const response = await instance.get('/nexa/analysis-templates');
  return response.data;
};

export const useGetAnalysisTemplates = ({ open }: { open?: boolean } = {}) => {
  return useQuery({
    queryKey: ['analysis-templates'],
    queryFn: getAnalysisTemplates,
    enabled: open !== false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
